import React from "react";
import { Sparkles } from "lucide-react";
import { Switch, Textarea } from "@/components/ui";
import { useShareFormLink } from "../../context/ShareFormLinkContext";

export function StepAIPersonalization() {
  const {
    allowsAi,
    useAiPersonalization,
    setUseAiPersonalization,
    setIsHelpOpen,
    contextInstructions,
    setContextInstructions,
    activeFanSelected,
  } = useShareFormLink();

  const displayName = activeFanSelected?.original?.displayName || activeFanSelected?.label?.split(" - ")[0] || "";
  const firstName = displayName?.split(" ")?.[0] || "John";

  if (!allowsAi) {
    return (
      <div className="flex flex-col gap-4 animate-in fade-in duration-300">
        <div className="flex flex-col gap-1.5">
          <h4 className="font-bold text-slate-800 text-lg">Step 3: AI Personalization</h4>
          <p className="text-sm text-slate-500 font-medium leading-relaxed">
            This feedback form does not support AI Personalization. You can proceed to the next step.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-4 animate-in fade-in duration-300">
      <div className="flex flex-col gap-1.5">
        <h4 className="font-bold text-slate-800 text-lg">Step 3: AI Personalization</h4>
        <p className="text-sm text-slate-500 font-medium leading-relaxed">
          Dynamically customize feedback questions with artificial intelligence based on specific details about the
          fan's experience.
        </p>
      </div>

      <div
        onClick={() => setUseAiPersonalization(!useAiPersonalization)}
        className="flex items-center justify-between w-full bg-slate-50 border border-slate-200/60 rounded-xl p-4 text-left cursor-pointer hover:bg-slate-100/50 transition-colors select-none"
      >
        <div className="flex flex-col gap-1 pr-4 flex-1">
          <span className="text-sm font-bold text-slate-800 flex items-center gap-1.5">
            <Sparkles className="size-4.5 text-primary shrink-0 fill-primary/10 animate-pulse" />
            Enable AI Personalization
          </span>
          <span className="text-sm text-slate-500 font-medium leading-normal mt-1">
            Let AI automatically tailor the questions.{" "}
            <button
              type="button"
              onClick={e => {
                e.stopPropagation();
                setIsHelpOpen(true);
              }}
              className="text-primary hover:text-primary/80 hover:underline font-bold border-none bg-transparent cursor-pointer p-0 outline-none"
            >
              Learn more
            </button>
          </span>
        </div>
        <Switch
          checked={useAiPersonalization}
          onCheckedChange={setUseAiPersonalization}
          onClick={e => e.stopPropagation()}
        />
      </div>

      {useAiPersonalization && (
        <div className="flex flex-col gap-2 w-full animate-in slide-in-from-top-1 duration-200">
          <label className="text-xs font-bold text-slate-500 uppercase tracking-wider text-left">
            Context / Experience Details (Optional)
          </label>
          <Textarea
            value={contextInstructions}
            onChange={e => setContextInstructions(e.target.value)}
            placeholder={`e.g. ${firstName} just closed on their first home.`}
            className="bg-white text-sm min-h-[120px] border-slate-200 leading-relaxed font-medium focus:ring-primary focus:border-primary rounded-xl p-3"
          />
        </div>
      )}
    </div>
  );
}
